import { render, staticRenderFns } from "./CorrespondenceTypeDashboard.vue?vue&type=template&id=5b252777&scoped=true"
import script from "./CorrespondenceTypeDashboard.vue?vue&type=script&lang=js"
export * from "./CorrespondenceTypeDashboard.vue?vue&type=script&lang=js"
import style1 from "./CorrespondenceTypeDashboard.vue?vue&type=style&index=1&id=5b252777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b252777",
  null
  
)

export default component.exports